import _get from 'lodash/get'

import {
    CHARITABLE_DONATIONS_SAVE_ERROR,
    CHARITABLE_DONATIONS_SAVE_SUCCESS,
    CHARITABLE_DONATIONS_SAVING,
    CHARITABLE_DONATIONS_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: null,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case CHARITABLE_DONATIONS_UPDATE:
            return { ...state, ...action.charitableDonations }

        case CHARITABLE_DONATIONS_SAVING:
            return { ...state, isSaving: true }

        case CHARITABLE_DONATIONS_SAVE_SUCCESS:
            return {
                ...state,
                ...action.charitableDonations,
                isSaving: false,
                goToNextQuestion: !action.charitableDonations.isAllowanceUpdate,
                goToNextAllowanceQuestion: action.charitableDonations.isAllowanceUpdate,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case CHARITABLE_DONATIONS_SAVE_ERROR:
            return {
                ...state,
                ...action.charitableDonations,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
